module.exports = __webpack_public_path__ + "static/img/risk-icon7.8d9c2fb8.png";